'use client'

import { ANONYMOUS_ID_KEY } from '@nwwp/segment-analytics'

const getAnonymousIdFromCookie = (): string | null => {
  try {
    const cookie = document.cookie
      .split(';')
      .map((value) => value.trim())
      .find((value) => value.startsWith(`${ANONYMOUS_ID_KEY}=`))

    if (!cookie) return null
    return decodeURIComponent(cookie.slice(ANONYMOUS_ID_KEY.length + 1))
  } catch {
    return null
  }
}

/** Segment anonymous id from localStorage or cookie; never throws. */
export const getAnonymousId = (): string | null => {
  try {
    const anonymousId = localStorage.getItem(ANONYMOUS_ID_KEY)
    if (!anonymousId) {
      return getAnonymousIdFromCookie()
    }

    try {
      const parsed: unknown = JSON.parse(anonymousId)
      return typeof parsed === 'string' ? parsed : anonymousId
    } catch {
      return anonymousId
    }
  } catch {
    return getAnonymousIdFromCookie()
  }
}
